export const sendLead = (sendLeadUrl, data, validToken) => fetch(sendLeadUrl, {
    method: "POST",
    body: JSON.stringify(data),
    credentials: "same-origin",
    headers: {
        Accept: "application/json",
        ...(validToken && { Authorization: `Bearer ${validToken}` }),
    },
});
